import { render, staticRenderFns } from "./UploadDBC.vue?vue&type=template&id=0373d7ec&scoped=true&"
import script from "./UploadDBC.vue?vue&type=script&lang=ts&"
export * from "./UploadDBC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373d7ec",
  null
  
)

export default component.exports